export default {"src":"/_next/static/media/shopping_cart_blue_icon.ef9b41fe.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};